/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace */

import { ServiceLocator } from "@/services/service.locator";
import { Injector       } from "@angular/core";

import { ActionType     } from './action.type';

/**
 *
 * @class Action
 *
 * @brief an action is Command...but for the GUI.  Any menu, or button, or toolbox button can
 * have an underlying action.  For example "Close Project".  For any given acton there is only
 * every one instance of the action, and it has associated attributes such a label, tool tip,
 * being enabled/active (or not) etc.   The sub-classes of the Action base class define all
 * the specific actions possible.
 *
 * We use the ActionService as the action Factory and Registry; when actions are modified
 * they "save" themselves in the ActionService, which then notifies any watchers of the
 * action that changed.  So if the action is used in a menu or in a toolbar, its presentation
 * can change as needed; for example if a project is closed, then the "Project Close" action
 * should now be disabled...because there is nothing to close.
 *
 * We allow for un-managed actions as well (Custom Action), so that menus and toolbars
 * can include dynamically generated items, for example "recent history".
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      July 2022
 *
 */
export class Action {

  /** the id of the alert, used to filter/search by text */
  public key:   string;

  /** the kind of alert in this stream */
  public type:  ActionType = ActionType.ACTION_CUSTOM;

  /** text to display for action */
  public label: string = 'No Label';

  /** icon to display for action */
  public icon:  string;

  /** hover text or bubble help for action */
  public tip:   string;

  /** any parameters/arguments for the action */
  public args: any[] = [];

  /** standard constructor, allow for partial action to be given */
  constructor(init?: Partial<Action>) {

    if (init) {

      Object.assign(this, init);
    }

    this.clearArgs();
  }

  /** clean out any old arguments */
  public clearArgs(): Action {

    this.args = [];

    return this;
  }

  /** append an argument */
  public addArg(arg: any): Action {

    this.args.push(arg);

    return this;
  }

  /* is this action enabled? */
  public enabled() : boolean {

    return true;
  }

  /** implement the action */
  public execute() : boolean {

    return false;
  }

  /** fetch the service injector */
  injector(): Injector {

    return ServiceLocator.injector;
  }

}
